"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _svgs = require("../../lib/svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Offline empty state component.
 * @param {Object} props - property object
 * @returns {ReactElement} markup
 */
var OfflineEmptyState = function OfflineEmptyState() {
  var ccxIngest = (0, _useIngest.default)();
  (0, _react.useEffect)(function () {
    ccxIngest.fireEvent(ccxIngest.events.offline); // disabling exhaustive-deps because ccxIngest should never change and if it does,
    // we dont want this to fire more than on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, null, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, _svgs.ErrorIllustration), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.offline-empty-state.title"
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Subtitle, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.offline-empty-state.subtitle"
  })));
};

var _default = OfflineEmptyState;
exports.default = _default;